import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import QssnLogo from './QssnLogo';
import { ROUTES } from '../routes';

const ArrowOut = () => (
  <svg viewBox="0 0 16 16" width="13" height="13" fill="none" style={{ stroke: 'currentColor', strokeWidth: 1.5 }}>
    <path d="M4 12 12 4M6 4h6v6" />
  </svg>
);

const NAV = [
  { to: ROUTES.howItWorks, label: 'How it works' },
  { to: ROUTES.security, label: 'Security' },
  { to: ROUTES.caseStudies, label: 'Impact' },
];

const linkStyle = ({ isActive }: { isActive: boolean }): React.CSSProperties => ({
  color: isActive ? 'var(--accent)' : 'var(--ink-2)',
  textDecoration: 'none',
});

const ctaStyle: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '.5rem',
  background: 'var(--ink)',
  color: 'var(--bg)',
  textDecoration: 'none',
  fontSize: '.8125rem',
  fontWeight: 500,
  padding: '.6rem 1.05rem',
  borderRadius: 8,
  whiteSpace: 'nowrap',
};

const SiteNav: React.FC = () => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <nav
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 50,
        background: 'var(--nav-bg)',
        backdropFilter: 'blur(14px)',
        WebkitBackdropFilter: 'blur(14px)',
        borderBottom: '1px solid var(--line)',
      }}
    >
      <div
        className="qssn-nav-inner"
        style={{
          maxWidth: 1200,
          margin: '0 auto',
          padding: '0 1.5rem',
          height: 68,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '2rem',
        }}
      >
        <Link to={ROUTES.home} onClick={close} style={{ display: 'flex', alignItems: 'center', color: 'var(--ink)', textDecoration: 'none' }}>
          <QssnLogo height={22} style={{ color: 'var(--ink)' }} />
        </Link>

        <div className="qssn-nav-links" style={{ display: 'flex', alignItems: 'center', gap: '2rem', fontSize: '.875rem' }}>
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} style={linkStyle}>
              {n.label}
            </NavLink>
          ))}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '.6rem' }}>
          <Link className="qssn-nav-cta" to={ROUTES.contact} onClick={close} style={ctaStyle}>
            Talk to us
            <ArrowOut />
          </Link>
          <button
            type="button"
            className="qssn-nav-toggle"
            aria-label={open ? 'Close menu' : 'Open menu'}
            aria-expanded={open}
            onClick={() => setOpen((o) => !o)}
            style={{
              alignItems: 'center',
              justifyContent: 'center',
              width: 38,
              height: 38,
              padding: 0,
              background: 'transparent',
              border: '1px solid var(--line-strong)',
              borderRadius: 8,
              color: 'var(--ink)',
              cursor: 'pointer',
            }}
          >
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" style={{ stroke: 'currentColor', strokeWidth: 1.7 }}>
              {open ? <path d="M6 6l12 12M18 6 6 18" /> : <path d="M4 7h16M4 12h16M4 17h16" />}
            </svg>
          </button>
        </div>
      </div>

      {open && (
        <div
          className="qssn-nav-menu"
          style={{
            borderTop: '1px solid var(--line)',
            background: 'var(--nav-bg)',
            backdropFilter: 'blur(14px)',
            WebkitBackdropFilter: 'blur(14px)',
            padding: '.5rem 1rem 1rem',
          }}
        >
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              onClick={close}
              style={({ isActive }) => ({
                display: 'block',
                padding: '.85rem .5rem',
                fontSize: '1rem',
                color: isActive ? 'var(--accent)' : 'var(--ink)',
                textDecoration: 'none',
                borderBottom: '1px solid var(--line)',
              })}
            >
              {n.label}
            </NavLink>
          ))}
          <NavLink
            to={ROUTES.contact}
            onClick={close}
            style={({ isActive }) => ({
              display: 'block',
              padding: '.85rem .5rem',
              fontSize: '1rem',
              color: isActive ? 'var(--accent)' : 'var(--ink)',
              textDecoration: 'none',
            })}
          >
            Contact
          </NavLink>
        </div>
      )}
    </nav>
  );
};

export default SiteNav;
